<template>
    <el-dialog title="接收入库" width="60%" :close-on-click-modal="false" append-to-body :visible.sync="visible">
        <el-form size="small" :inline="true" :model="form" ref="form" label-width="140px" :rules="dataRule" v-loading="loading">
            <el-form-item label="入库点交人：" prop="handPerson">
                <el-select v-model="form.handPerson" filterable placeholder="请选择" clearable>
                    <el-option v-for="item in userOpt" :key="item.id" :label="item.name"
                               :value="item.id"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="入库点收人：" prop="tallyTaker">
                <el-select v-model="form.tallyTaker" filterable placeholder="请选择" clearable>
                    <el-option v-for="item in userOpt" :key="item.id" :label="item.name"
                               :value="item.id"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="交接时间：" prop="joinData">
                <el-date-picker class="w100i"
                        v-model="form.joinData"
                        type="date"
                        placeholder="选择日期" format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd">
                </el-date-picker>
            </el-form-item>
            <div class="m_b1">回库藏品：</div>
            <el-table
                    :data="form.dataList"
                    v-loading="tableLoading"
                    size="small" max-height="320"
                    class="table" border>
                <el-table-column prop="mingcheng" label="藏品名称" show-overflow-tooltip></el-table-column>
                <el-table-column prop="collectionNumber" label="藏品编号" show-overflow-tooltip></el-table-column>
                <el-table-column prop="rukubianhaopscaxvynpk" label="入库编号" show-overflow-tooltip></el-table-column>
                <el-table-column prop="kufangmingchengipuzvxgwkg" label="库房名称" width="180">
                    <template slot="header">
                        <span class="redColor">* </span>
                        <span>库房名称</span>
                    </template>
                    <template slot-scope="scope">
                        <el-form-item :prop="'dataList.' + scope.$index + '.kufangmingchengipuzvxgwkg'" :rules="dataRule.kufangmingchengipuzvxgwkg">
                            <el-select v-model="scope.row.kufangmingchengipuzvxgwkg" filterable placeholder="请选择" clearable size="mini">
                                <el-option v-for="(item, index) in roomOpt" :key="index" :label="item.jsonData.kufangmingchengipuzvxgwkg"
                                           :value="item.jsonData.kufangmingchengipuzvxgwkg"></el-option>
                            </el-select>
                        </el-form-item>
                    </template>
                </el-table-column>
                <el-table-column prop="cunfangweizhirpphkjtyly" label="存放位置" width="180">
                    <template slot-scope="scope">
                        <el-form-item :prop="'dataList.' + scope.$index + '.cunfangweizhirpphkjtyly'" :rules="dataRule.cunfangweizhirpphkjtyly">
                            <el-select v-model="scope.row.cunfangweizhirpphkjtyly" filterable placeholder="请选择" clearable size="mini">
                                <el-option v-for="(item, index) in locationOpt" :key="index" :label="item.jsonData.mingchengonygubiyct"
                                           :value="item.jsonData.mingchengonygubiyct"></el-option>
                            </el-select>
                        </el-form-item>
                    </template>
                </el-table-column>
            </el-table>
            <pagination :total="total" :page.sync="searchForm.current" :limit.sync="searchForm.size"
                        @pagination="saveData"/>
        </el-form>
        <div slot="footer" class="text_center">
            <el-button size="small" @click="visible = false">取消</el-button>
            <el-button size="small" type="primary" :disabled="loading" @click="doSubmit()" v-noMoreClick>确定</el-button>
        </div>
    </el-dialog>
</template>

<script>
    export default {
        name: "storage",
        data() {
            return {
                visible: false,
                loading: false,
                tableLoading: false,
                form: {
                    handPerson: '',
                    tallyTaker: JSON.parse(sessionStorage.getItem('userInfo')).id || '',
                    joinData: new Date(),
                    dataList: [],
                },
                searchForm: {
                    cacheId: '',
                    basicDataId: '',
                    dataIds: '',
                    current: 1,
                    size: 20,
                },
                total: 0,
                userOpt: [],
                roomOpt: [],
                locationOpt: [],
                dataRule: {
                    handPerson: [
                        {required: true, message: '入库点交人不能为空', trigger: 'change'}
                    ],
                    tallyTaker: [
                        {required: true, message: '入库点收人不能为空', trigger: 'change'}
                    ],
                    joinData: [
                        {required: true, message: '交接时间不能为空', trigger: 'change'}
                    ],
                    kufangmingchengipuzvxgwkg: [
                        {required: true, message: '库房名称不能为空', trigger: 'change'}
                    ],
                }
            }
        },
        methods: {
            init(basicDataId, ids) {
                this.searchForm.basicDataId = basicDataId
                this.searchForm.dataIds = ids
                this.form.dataList = []
                this.userOpt = []
                this.roomOpt = []
                this.locationOpt = []
                this.getList()
                this.getRoom()
                this.visible = true
                this.$nextTick(() => {
                    this.$refs['form'].resetFields()
                })
            },
            // 获取列表数据
            getList() {
                this.tableLoading = true
                this.$axios(this.api.metadata.batchReception, this.searchForm, 'post').then(data => {
                    if (data.status) {
                        this.searchForm.cacheId = data.data.cacheId
                        this.form.dataList = data.data.data.records
                        this.total = parseInt(data.data.data.total)
                        this.$nextTick(() => {
                            this.$refs.form.clearValidate()
                        })
                    } else {
                        this.$message.error('查询失败')
                    }
                    this.tableLoading = false
                })
            },
            // 保存入库临时数据
            saveData() {
                this.loading = true
                this.$axios(this.api.metadata.editTemp, {
                    cacheId: this.searchForm.cacheId,
                    metadataCollectionDataVOList: this.form.dataList,
                }, 'post').then(data => {
                    if (data.status) {
                       this.getList()
                    }
                    this.loading = false
                })
            },
            // 获取所有库房、位置、用户
            getRoom() {
                this.loading = true
                this.$axios(this.api.metadata.selectAllStoreroom).then(data => {
                    if (data.status) {
                        this.roomOpt = data.data
                    }
                    this.loading = false
                })
                this.$axios(this.api.metadata.selectAllContainer).then(data => {
                    if (data.status) {
                        this.locationOpt = data.data
                    }
                })
                this.$axios(this.api.user.sysuserQueryAllList, {
                    current: 1,
                    size: 9999,
                    orderBy: '',
                    name: '',
                    loginName: '',
                }, 'get').then(data => {
                    if (data && data.status) {
                        this.userOpt = data.data.records
                    }
                })
            },
            // 确定
            doSubmit() {
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        this.loading = true
                        let p = JSON.parse(JSON.stringify(this.form))
                        p.cacheId = this.searchForm.cacheId
                        delete p.dataList
                        this.$axios(this.api.metadata.metadataCollectionSubmit, p, 'post').then(data => {
                            if (data.status) {
                                this.$message.success('操作成功')
                                this.$emit('refreshData')
                                this.visible = false
                            } else {
                                this.$message.error(data.msg)
                            }
                            this.loading = false
                        })
                    }
                })
            }
        }
    }
</script>

<style scoped>

</style>
